export default __webpack_public_path__ + "static/media/logo-red.a05ce325.png";